import styled from 'styled-components';
import { getTranslatedText, DeleteModal } from '@nile/components';
import React from 'react';
import { injectIntl } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';

/**
 * Cells are specific to the components using the table.
 * This action cell is used to delete a specific item in the table.
 */

function ActionCell(props) {
  const { cell, intl } = props;
  const meta = cell?.row?.original;
  const { actions, labels } = cell.column;
  return (
    <div
      className="ml8 deleteItem cursor-pointer"
      onClick={() => {
        actions.onChange({
          miscProperty: 'delete',
          miscItem: cell.row.original
        });
      }}
    >
      <div id={`delete-list-item${cell?.row?.id ? `-${cell.row.id}` : ''}`}>
        <SVGIcon name="Delete" />
      </div>
    </div>
  );
}

export default injectIntl(ActionCell);
